module.exports = __webpack_public_path__ + "media/images/brand/jcb-83dd987edaa80b0a64fe937911a068f7.png";